import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleMinus } from '@fortawesome/free-solid-svg-icons';
import file from '../assets/images/file.png'
import phone from '../assets/images/callxmimar.png'
import envelope from '../assets/images/emailxmimar.png'
import globe from '../assets/images/globexmimar.png'
import map from '../assets/images/locxmimar.png'
import linkedIn from '../assets/images/inxmimar.png'
import { useProfileContext } from '../hooks/useProfileContext';
import { useUserContext } from '../hooks/useUserContext';
import { useEffect, useState } from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { useParams } from 'react-router-dom';
const BusinessLinks = ({ corp, props, color, idx }) => {
    const { profile, dispatch } = useProfileContext();
    const { user } = useUserContext()
    const [isLoading, setIsLoading] = useState(false)
    const { id } = useParams();
    const { Name } =useParams()
    useEffect(() => { }, [dispatch])
    console.log(props)
    let icon;
    switch (props.PlatformIcon) {
        case "map":
            icon = map
            break;
        case "phone":
            icon = phone
            break;
        case "globe":
            icon = globe
            break;
        case "envelope":
            icon = envelope
            break;  
        case "file":
            icon = file
            break;
    }

    const handleAppRemove = async (e) => {
        e.preventDefault();
        setIsLoading(true)
        console.log(props)
        const formData = new FormData();
        formData.append('Email', profile.email);
        formData.append('ProfileIdx', profile.activeProfile);
        formData.append('AppIndex', idx);
        formData.append('PlatformLink', props.PlatformLink);

        try{
            await axios.post( `/users/deleteSm`, formData, {
                withCredentials: true,
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "X-Requested-With": "XMLHttpRequest",
                    'Authorization': `Bearer ${user.token}`
                },
            })
                .then(async (res) => {
                    const json = res.data
                    console.log(json)
                    dispatch({ type: "UPDATE_PROFILES", payload: json })
                setIsLoading(false)
                })
        }
        catch(err){
            console.log(err)
            console.log("No internet connection")
        }
    }

    const handleAppAnalytics = async () => {
        const formData = new FormData();
        formData.append('Name', Name);
        formData.append('id', id);
        formData.append('AppIndex', idx);
        console.log("here")
        await axios.post(`/analytics/appTap`, formData, {
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest",
            },
        })
            .then(async (res) => {
                const json = res.data
                console.log(json)
            })
            .catch((err) => {
                console.log("No internet Connection")
            })
    }

    return (
        <div style={{'width':'100%'}}>
            {!isLoading ? <a target="_blank" style={{ 'background': `rgba(${color},.4)` }} onClick={!corp ? handleAppAnalytics : undefined} className='businessLink' href={(icon === phone) ? "tel:" + props.PlatformLink : props.PlatformLink}>
                {corp && <div className='businessRemoveContainer'>
                    <FontAwesomeIcon onClick={e => handleAppRemove(e)} className='removeIcon' icon={faCircleMinus} />
                </div>}
                <img style={{ 'width': '32px', 'height': '32px', "padding": '5px' }} src={ props.PlatformIcon[0]==='/' || props.PlatformIcon[0]==='d'  ? props.PlatformIcon : icon} />
                <span className='business-links-mobile'>{props.PlatformName}</span>
            </a> : <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open
            >
                <CircularProgress color="inherit" />
            </Backdrop>}
        </div>
    );
}

export default BusinessLinks